import React, { useEffect, useState } from "react";
import "./real.css";
import axios from "axios";

export default function Real() {
  const [one, setOne] = useState([]);
  const [two, setTwo] = useState([]);
  const [three, setThree] = useState([]);
  useEffect(() => {
    axios.get("http://www.itemev.com/home/Shishi").then((response) => {
      setOne(response.data[0].title);
      setTwo(response.data[1].title);
      setThree(response.data[2].title);
    });
  }, []);



  return (
    <div className="real">
      <div className="real-title">
        <span>实时脉搏</span>
      </div>
      {one !== [] && (
        <div className="scroller">
          <span className="scrollers">
            <span className="scrollers">
              <div
                className="scroller-small"
                onClick={() => {
                  window.open(
                    `https://www.baidu.com/s?ie=UTF-8&tn=02003390_42_hao_pg&wd=${one}`
                  );
                }}
              >
                {one}
              </div>
            </span>
          </span>
        </div>
      )}

      {two !== [] && (
        <div className="scroller-one">
          <span className="scrollers">
            <div
              className="scroller-small"
              onClick={() => {
                window.open(
                  `https://www.baidu.com/s?ie=UTF-8&tn=02003390_42_hao_pg&wd=${two}`
                );
              }}
            >
              {two}
            </div>
          </span>
        </div>
      )}
      {three !== [] && (
        <div className="scroller-two">
          <span className="scrollers">
            <div
              className="scroller-small"
              onClick={() => {
                window.open(
                  `https://www.baidu.com/s?ie=UTF-8&tn=02003390_42_hao_pg&wd=${three}`
                );
              }}
            >
              {three}
            </div>
          </span>
        </div>
      )}
    </div>
  );
}
